export { GlobalConfirmDialog } from './ConfirmDialog';
export {
  closeConfirmDialog,
  confirmDialogManager,
  openConfirmDialog,
  toggleConfirmLoading,
} from './model';
